export class DiaryPermissions {
    public static readonly read: string = 'diarymanager:read:diary';
    public static readonly calendar: string = 'diarymanager:read:calendar';
    public static readonly list: string = 'diarymanager:read:list';
    public static readonly filter: string = 'diarymanager:read:filter';
}
